import React from 'react';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import { Link } from 'react-router-dom'; //  to change path from inside or to alter react-router-dom path
import styles from './MyrbLogo.scss';// to import local scss fle

const MyrbLogo = () => (
  <div className={cn('col s12')}>
    <Link to="/">
      <img className={cn('col s12', styles.rblogo)} src="https://media.dev.myrecruitboard.com/Images/logo_footer.png" alt="logo" />
    </Link>
  </div>
);

export default MyrbLogo;



// WEBPACK FOOTER //
// ./src/components/MyrbLogo/MyrbLogo.js